export enum EPlanType {
  CINCH = 'cinch',
  PICNIC = 'picnic',
  BREEZE = 'breeze',
}

export type PlanType = EPlanType.CINCH | EPlanType.PICNIC | EPlanType.BREEZE;

export interface Plan {
  expiresAt: number;
  extraChannels: number;
  extraWorkspaces: number;
  type: PlanType;
  version: number;
  interval: string;
  status: 'active' | 'cancelled';
  limits: {
    files: PlanFileLimits;
  };
}

export interface PlanSwitchResponse {
  name: EPlanType;
  expiresAt: string | null;
}

export interface PlanFileLimits {
  maxCount: number;
  maxUploadBytes: number;
  totalStorageBytes: number;
}
